// カラーリップ製品データ

export const colorProducts = [
	{
		id: 'sheer-orange-beige',
		name: 'DHC リップクリーム<br class="d-md-none">シアーオレンジベージュ',
		price: '770',
		newIcon: './assets/images/products/color/i_new_orange.svg',
		spf: 'SPF22/PA++',
		tag: null,
		mainCopy: 'うるおって、ぱっと華やぐ<br>オレンジリップ',
		description: 'シアーに溶け込むオレンジベージュが、<br class="d-sm-none">唇に華やかな血色感をオン。<br><br>シアーな美発色と濃密保湿に加え、<br>ボリュームアップ<sup>※</sup>も叶える<br class="d-sm-none">カラーリップクリームです。',
		badges: ['無香料', 'パラベンフリー', '天然成分配合'],
		images: {
			lips: './assets/images/products/color/orange_mouth.webp',
			paste: './assets/images/products/color/orange_paste.webp',
		},
		colorChart: './assets/images/products/color/orange_chart.webp',
	},
	{
		id: 'sheer-brown-beige',
		name: 'DHC リップクリーム<br class="d-md-none">シアーブラウンベージュ',
		price: '770',
		newIcon: './assets/images/products/color/i_new_brown.svg',
		spf: 'SPF22/PA++',
		tag: null,
		mainCopy: 'うるおって、ちゃんと大人な<br>ブラウンリップ',
		description: '落ち着きを纏う透明感を唇に。<br class="d-sm-none">大人のブラウンベージュ。<br><br>シアーな美発色と濃密保湿に加え、<br>ボリュームアップ<sup>※</sup>も叶える<br class="d-sm-none">カラーリップクリームです。',
		badges: ['無香料', 'パラベンフリー', '天然成分配合'],
		images: {
			lips: './assets/images/products/color/brown_mouth.webp',
			paste: './assets/images/products/color/brown_paste.webp',
		},
		colorChart: './assets/images/products/color/brown_chart.webp',
	},
	{
		id: 'sheer-red',
		name: 'DHC リップクリーム<br class="d-md-none">シアーレッド',
		price: '770',
		newIcon: null,
		spf: 'SPF22/PA++',
		tag: null,
		mainCopy: '肌に血色のリズムを<br>シアーレッド',
		description: 'ナチュラルな大人可愛い血色感を。<br class="d-sm-none">唇に素直に溶け込むレッドカラー。<br><br>シアーな美発色と濃密保湿に加え、<br>ボリュームアップ<sup>※</sup>も叶える<br class="d-sm-none">カラーリップクリームです。',
		badges: ['無香料', 'パラベンフリー', '天然成分配合'],
		images: {
			lips: './assets/images/products/color/red_mouth.webp',
			paste: './assets/images/products/color/red_paste.webp',
		},
		colorChart: './assets/images/products/color/red_chart.webp',
	},
	{
		id: 'sheer-rose-pink',
		name: 'DHC リップクリーム<br class="d-md-none">シアーローズピンク',
		price: '770',
		newIcon: null,
		spf: 'SPF22/PA++',
		tag: null,
		mainCopy: '気分が花ひらく<br>シアーローズピンク',
		description: '唇に上品と可愛さを。<br class="d-sm-none">華やかな青みローズピンク。<br><br>シアーな美発色と濃密保湿に加え、<br>ボリュームアップ<sup>※</sup>も叶える<br class="d-sm-none">カラーリップクリームです。',
		badges: ['無香料', 'パラベンフリー', '天然成分配合'],
		images: {
			lips: './assets/images/products/color/pink_mouth.webp',
			paste: './assets/images/products/color/pink_paste.webp',
		},
		colorChart: './assets/images/products/color/pink_chart.webp',
	},
	{
		id: 'sheer-bordeaux',
		name: 'DHC リップクリーム<br>シアーボルドー',
		price: '770',
		newIcon: null,
		spf: 'SPF22/PA++',
		tag: null,
		mainCopy: '肌に溶け込む血色感<br>シアーボルドー',
		description: '透け感の中に深みを宿すボルドーが、<br class="d-sm-none">艶やかな血色感を演出。<br><br>シアーな美発色と濃密保湿に加え、<br>ボリュームアップ<sup>※</sup>も叶える<br class="d-sm-none">カラーリップクリームです。',
		badges: ['無香料', 'パラベンフリー', '天然成分配合'],
		images: {
			lips: './assets/images/products/color/bordeaux_mouth.webp',
			paste: './assets/images/products/color/bordeaux_paste.webp',
		},
		colorChart: './assets/images/products/color/bordeaux_chart.webp',
	},
];
